module.exports = __webpack_public_path__ + "img/xianjin.81efeb58.png";